// extracted by mini-css-extract-plugin
export default {"indexSortWrapper":"IndexSort-module__indexSortWrapper__ku8pzw3"};